import { lazy } from "react";

const AllSales = lazy(() => import("./AllSales"));
const Customers = lazy(() => import("./Customers"));
const ProductsAndServices = lazy(() => import("./ProductsAndServices"));

const SalesRoutes = [
  {
    path: "/sales/allSales",
    element: <AllSales />,
  },
  {
    path: "/sales/Customers",
    element: <Customers />,
  },
  {
    path: "/sales/products-services",
    element: <ProductsAndServices />,
  },
];

export default SalesRoutes;
